module.exports = __webpack_public_path__ + "aa498afca4f78743329740484b6cec28.svg";